import { ReactElement } from 'react';

import { TranslatableText } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { onlinePaymentsTranslationKeys } from '../translations';

import { OnlinePaymentsPanel } from './OnlinePaymentsPanel';

type OnlinePaymentsNavTab<PARAM_NAME extends string> = {
   param: PARAM_NAME;
   label: TranslatableText;
   content: ReactElement;
};

type UseOnlinePaymentsNavTabOptions<PARAM_NAME> = {
   param: PARAM_NAME;
};

export const useOnlinePaymentsNavTab = <PARAM_NAME extends string>(
   options: UseOnlinePaymentsNavTabOptions<PARAM_NAME>
): OnlinePaymentsNavTab<PARAM_NAME> | null | undefined => {
   return protectFeature(
      'managingOnlinePaymentsConfiguration',
      {
         content: <OnlinePaymentsPanel />,
         label: onlinePaymentsTranslationKeys.tabName,
         param: options.param,
      },
      null
   );
};
